export default __webpack_public_path__ + "static/media/baroz-logo.6ae5890b.png";